import { render } from "./GridVendedorDesempenho.vue?vue&type=template&id=9a64715a"
import script from "./GridVendedorDesempenho.vue?vue&type=script&lang=js"
export * from "./GridVendedorDesempenho.vue?vue&type=script&lang=js"

import "./GridVendedorDesempenho.vue?vue&type=style&index=0&id=9a64715a&lang=css"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__